<script>
import Breadcrumbs from "@js/components/Breadcrumbs/Breadcrumbs.vue";
import MobileTopBar from "@js/components/TopBar/MobileTopBar.vue";
import {contacts} from "@js/company_details.ts";

export default {
    name: "PrivacyPolicyPage",
    components: {MobileTopBar, Breadcrumbs},
    setup() {
        return {
            contacts,
        }
    }
}
</script>

<template>
    <MobileTopBar/>
    <div class="container mx-auto">
        <Breadcrumbs class="mb-2"/>
        <h1 class="text-2xl md:text-3xl">
            Политика конфиденциальности
        </h1>
        <hr class="mt-5 mb-5"/>

        <div class="mb-10">
            <h2 class="text-xl md:text-2xl mb-5">
                1. Общие положения
            </h2>
            <p class="text-sm mb-2">
                Настоящая Политика конфиденциальности определяет порядок обработки и защиты персональных данных
                пользователей сайта Вторчермет-1. Мы уважаем право каждого посетителя сайта на неприкосновенность
                частной жизни и принимаем необходимые меры для защиты получаемой информации.
            </p>
            <p class="text-sm mb-2">
                Политика применяется ко всей информации, которую сайт может получить о пользователе при посещении сайта,
                заполнении форм обратной связи, заказе звонка, отправке заявки на вывоз металлолома, оценку лома,
                согласовании демонтажа, отправке фотографий, документов и иных файлов.
            </p>
            <p class="text-sm mb-2">
                Используя сайт, вы подтверждаете согласие с условиями настоящей Политики. Если вы не согласны с
                условиями обработки данных, пожалуйста, воздержитесь от использования сайта и отправки форм.
            </p>
        </div>

        <div class="mb-10">
            <h2 class="text-xl md:text-2xl mb-5">
                2. Какие данные мы можем собирать
            </h2>
            <p class="text-sm mb-2">
                В зависимости от того, какой формой или сервисом сайта вы пользуетесь, мы можем получать следующие
                данные:
            </p>
            <ul class="text-sm list-disc pl-5 space-y-2">
                <li>имя, фамилию, отчество или иные сведения, указанные вами добровольно;</li>
                <li>номер телефона;</li>
                <li>адрес электронной почты;</li>
                <li>адрес вывоза металлолома, адрес объекта или иные сведения о местоположении, указанные в заявке;</li>
                <li>сведения о характере металлолома, его объёме, состоянии, типе, засоренности и предполагаемом весе;</li>
                <li>фотографии, видео, документы и иные файлы, которые вы направляете через формы сайта или мессенджеры;</li>
                <li>реквизиты организации, ИНН, контактные данные представителя, если заявка оформляется от имени юрлица или ИП;</li>
                <li>сведения, содержащиеся в сообщении, комментарии или заявке;</li>
                <li>технические данные: IP-адрес, cookie, сведения о браузере, устройстве, времени посещения, источнике перехода, действиях на сайте.</li>
            </ul>
            <p class="text-sm mt-3">
                Мы не просим пользователей размещать избыточные персональные данные, не требующиеся для обработки
                заявки. Просим не передавать через формы сайта специальные категории персональных данных и иную
                информацию, не связанную с целью обращения.
            </p>
        </div>

        <div class="mb-10">
            <h2 class="text-xl md:text-2xl mb-5">
                3. Цели обработки персональных данных
            </h2>
            <p class="text-sm mb-2">
                Персональные данные используются исключительно в разумных и законных целях, связанных с работой сайта и
                деятельностью Вторчермет-1, в том числе для:
            </p>
            <ul class="text-sm list-disc pl-5 space-y-2">
                <li>обработки входящих заявок и обращений;</li>
                <li>связи с пользователем по телефону, e-mail, через мессенджеры или иными указанными способами;</li>
                <li>предварительной оценки металлолома по фото, описанию или заявленным параметрам;</li>
                <li>согласования условий вывоза, демонтажа, сортировки, взвешивания и расчета;</li>
                <li>оформления документов, необходимых для сделки, приема металлолома, вывоза или демонтажа;</li>
                <li>исполнения обязательств перед клиентом и ведения клиентской поддержки;</li>
                <li>улучшения качества работы сайта, аналитики посещаемости и повышения удобства пользования сервисом;</li>
                <li>предотвращения спама, злоупотреблений и автоматических отправок через формы сайта.</li>
            </ul>
        </div>

        <div class="mb-10">
            <h2 class="text-xl md:text-2xl mb-5">
                4. Правовые основания обработки
            </h2>
            <p class="text-sm mb-2">
                Мы обрабатываем персональные данные на основании добровольного предоставления данных пользователем,
                согласия на обработку персональных данных, а также в случаях, когда обработка необходима для ответа на
                обращение, заключения и исполнения договора, соблюдения требований законодательства Российской
                Федерации и защиты законных интересов компании.
            </p>
            <p class="text-sm mb-2">
                Отправляя форму на сайте, вы подтверждаете, что предоставленные данные являются актуальными и относятся
                к вам либо что вы обладаете необходимыми полномочиями на передачу таких данных.
            </p>
        </div>

        <div class="mb-10">
            <h2 class="text-xl md:text-2xl mb-5">
                5. Файлы cookie и технические данные
            </h2>
            <p class="text-sm mb-2">
                Сайт может использовать cookie и иные технические средства для корректной работы страниц, запоминания
                пользовательских настроек, анализа трафика, определения источников обращений и улучшения сервиса.
            </p>
            <p class="text-sm mb-2">
                Cookie не используются нами для установления личности посетителя без необходимости, однако в сочетании с
                другой информацией они могут относиться к персональным данным в случаях, предусмотренных
                законодательством.
            </p>
            <p class="text-sm mb-2">
                Вы можете изменить настройки cookie в браузере. При отключении части cookie отдельные функции сайта
                могут работать некорректно.
            </p>
        </div>

        <div class="mb-10">
            <h2 class="text-xl md:text-2xl mb-5">
                6. Использование сторонних сервисов
            </h2>
            <p class="text-sm mb-2">
                На сайте могут использоваться сторонние сервисы, необходимые для обработки заявок, аналитики,
                антиспам-защиты, телефонии, CRM, коллтрекинга, рекламы и технического обеспечения работы форм.
            </p>
            <p class="text-sm mb-2">
                В частности, это могут быть сервисы веб-аналитики, рекламные инструменты, captcha-сервисы, CRM-системы,
                сервисы телефонии, мессенджеры, почтовые сервисы и иные интеграции, используемые для обработки заявок и
                обратной связи.
            </p>
            <p class="text-sm mb-2">
                Такие сервисы могут самостоятельно обрабатывать технические данные в соответствии со своими правилами и
                пользовательскими документами. Мы рекомендуем ознакомиться с политиками конфиденциальности
                соответствующих сервисов.
            </p>
        </div>

        <div class="mb-10">
            <h2 class="text-xl md:text-2xl mb-5">
                7. Передача данных третьим лицам
            </h2>
            <p class="text-sm mb-2">
                Мы не продаем и не передаем персональные данные третьим лицам без достаточных оснований. Передача
                возможна только в следующих случаях:
            </p>
            <ul class="text-sm list-disc pl-5 space-y-2">
                <li>если это необходимо для обработки вашей заявки и исполнения обязательств перед вами;</li>
                <li>если в цепочке оказания услуги участвуют подрядчики, перевозчики, специалисты по демонтажу, CRM или иные исполнители;</li>
                <li>если обязанность по передаче предусмотрена законодательством РФ, требованием суда или уполномоченного органа;</li>
                <li>если пользователь дал отдельное согласие на такую передачу.</li>
            </ul>
            <p class="text-sm mt-3">
                В случае передачи данных подрядчикам мы требуем использовать полученную информацию только в объеме,
                необходимом для выполнения соответствующей задачи.
            </p>
        </div>

        <div class="mb-10">
            <h2 class="text-xl md:text-2xl mb-5">
                8. Сроки хранения данных
            </h2>
            <p class="text-sm mb-2">
                Персональные данные хранятся не дольше, чем это необходимо для достижения целей обработки, исполнения
                обязательств, ответа на запрос пользователя, соблюдения требований законодательства, бухгалтерского и
                налогового учета, а также урегулирования возможных споров и претензий.
            </p>
            <p class="text-sm mb-2">
                После достижения целей обработки либо при утрате необходимости в данных они подлежат удалению,
                обезличиванию или уничтожению, если иное не предусмотрено законодательством.
            </p>
        </div>

        <div class="mb-10">
            <h2 class="text-xl md:text-2xl mb-5">
                9. Права пользователя
            </h2>
            <p class="text-sm mb-2">
                Пользователь вправе запросить сведения о своих персональных данных, потребовать их уточнения,
                блокирования или удаления, а также отозвать согласие на обработку персональных данных в случаях, когда
                это допускается законодательством.
            </p>
            <p class="text-sm mb-2">
                Для реализации своих прав вы можете направить обращение по адресу: {{ contacts.info_mail }}.
                В обращении желательно указать, какие именно данные и по какому вопросу необходимо уточнить,
                изменить или удалить.
            </p>
        </div>

        <div class="mb-10">
            <h2 class="text-xl md:text-2xl mb-5">
                10. Безопасность данных
            </h2>
            <p class="text-sm mb-2">
                Мы принимаем разумные организационные и технические меры для защиты персональных данных от
                неправомерного доступа, изменения, раскрытия, уничтожения, блокирования, копирования и иных
                неправомерных действий.
            </p>
            <p class="text-sm mb-2">
                При этом пользователь также обязан самостоятельно обеспечивать безопасность своих устройств, каналов
                связи и не передавать третьим лицам доступ к своим средствам коммуникации, если через них ведется
                взаимодействие с компанией.
            </p>
        </div>

        <div class="mb-10">
            <h2 class="text-xl md:text-2xl mb-5">
                11. Данные несовершеннолетних
            </h2>
            <p class="text-sm mb-2">
                Сайт не предназначен для самостоятельного использования несовершеннолетними без участия законных
                представителей. Если вы полагаете, что несовершеннолетний предоставил нам свои данные без согласия
                родителей или законных представителей, пожалуйста, сообщите нам об этом по адресу {{ contacts.info_mail }}.
            </p>
        </div>

        <div class="mb-10">
            <h2 class="text-xl md:text-2xl mb-5">
                12. Ссылки на сторонние сайты
            </h2>
            <p class="text-sm mb-2">
                На сайте могут размещаться ссылки на сторонние ресурсы. Мы не контролируем содержание и правила
                обработки данных на таких сайтах и не несем ответственности за действия их владельцев.
            </p>
            <p class="text-sm mb-2">
                Перед использованием сторонних сайтов рекомендуем ознакомиться с их условиями и политиками
                конфиденциальности.
            </p>
        </div>

        <div class="mb-10">
            <h2 class="text-xl md:text-2xl mb-5">
                13. Изменение политики конфиденциальности
            </h2>
            <p class="text-sm mb-2">
                Мы вправе вносить изменения в настоящую Политику конфиденциальности без предварительного уведомления
                пользователей. Актуальная редакция всегда размещается на данной странице.
            </p>
            <p class="text-sm mb-2">
                Продолжение использования сайта после публикации новой редакции означает согласие пользователя с
                обновленными условиями, если иное не следует из существа изменений.
            </p>
        </div>

        <div class="mb-10">
            <h2 class="text-xl md:text-2xl mb-5">
                14. Контакты
            </h2>
            <p class="text-sm mb-2">
                По всем вопросам, связанным с обработкой персональных данных и настоящей Политикой конфиденциальности,
                вы можете связаться с администрацией сайта по адресу: {{ contacts.info_mail }}.
            </p>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
